import type { IntakeCategory, IntakeCaseState } from '../services/inboundInboxService';
import { getInboxCategoryConfigFor } from './inboxCategoryConfig';

export const getCategoryDisplay = (args: {
  category?: IntakeCategory | string | null;
  linkedQuoteId?: string | null;
  linkedQuoteMode?: string | null;
  convertedAt?: string | null;
}) => {
  const category = String(args.category || '').trim().toUpperCase() as IntakeCategory;
  const linkedMode = String(args.linkedQuoteMode || '').trim().toUpperCase();
  const isFinal = !!(args.linkedQuoteId || args.convertedAt) && (linkedMode === 'CHARTER' || linkedMode === 'SCHEDULED');
  if (isFinal && linkedMode === 'CHARTER') {
    const meta = getInboxCategoryConfigFor('PRIVATE_BALLOON');
    return { label: meta.label, tone: meta.key as IntakeCategory, final: true };
  }
  if (isFinal && linkedMode === 'SCHEDULED') {
    const meta = getInboxCategoryConfigFor('SHARED_BALLOON');
    return { label: meta.label, tone: meta.key as IntakeCategory, final: true };
  }
  const meta = getInboxCategoryConfigFor(category);
  return { label: meta.label, tone: meta.key as IntakeCategory, final: category === 'CONCIERGE' || meta.key === 'CONCIERGE_VIP' };
};

export const getVerificationLabel = (status?: string | null) => {
  const key = String(status || '').toUpperCase();
  if (key === 'VERIFIED') return 'Verified (Zoho)';
  if (key === 'TRUSTED') return 'Known Contact';
  return 'Needs Verification';
};

export const getReplySourceLabel = (value?: string | null) => {
  const key = String(value || '').trim().toUpperCase();
  if (!key) return 'Outbound';
  if (key === 'GMAIL_API' || key === 'SMTP' || key === 'INBOUND_HUB' || key === 'INBOUND_HUB_REPLY' || key === 'MA-OS PANEL' || key === 'MA-OS_PANEL') {
    return 'MA-OS Panel';
  }
  return String(value || '').trim();
};

export const getCaseStateLabel = (state?: IntakeCaseState | null) => {
  if (state === 'RESOLVED_WON') return 'Closed Won';
  if (state === 'RESOLVED_LOST') return 'Closed Lost';
  if (state === 'WAITING_CLIENT') return 'Waiting Client';
  if (state === 'NO_ACTION') return 'Closed';
  return 'Pending Reply';
};

export const getSlaStatusText = (caseState?: IntakeCaseState | null, level?: string | null, ageMinutes?: number | null) => {
  if (ageMinutes !== null && ageMinutes !== undefined) {
    return `SLA ${level || 'GREEN'} - ${Math.max(0, Math.floor(ageMinutes))}m`;
  }
  if (caseState === 'WAITING_CLIENT') return 'SLA Paused - Waiting Client';
  if (caseState === 'RESOLVED_WON') return 'SLA Paused - Closed Won';
  if (caseState === 'RESOLVED_LOST') return 'SLA Paused - Closed Lost';
  if (caseState === 'NO_ACTION') return 'SLA Paused - Closed';
  return 'SLA Paused';
};
